import React, { useState } from "react";
import pdf from "../../files/Resume.pdf";
import { Worker } from "@react-pdf-viewer/core";
// Import the main component
import { Viewer } from "@react-pdf-viewer/core";
// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./ResumePage.css";

function ResumePage() {
  const [pdfFile, setPdfFile] = useState(pdf);
  return (
    <div className="container">
      <div className="viewer">
        {pdfFile ? (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js">
            <Viewer fileUrl={pdfFile} />;
          </Worker>
        ) : (
          <div>No file is selected yet</div>
        )}
      </div>
    </div>
  );
}

export default ResumePage;
